import { createSlice } from "@reduxjs/toolkit";

export const SMALL_VIEWPORT = "small";
export const MEDIUM_VIEWPORT = "medium";
export const LARGE_VIEWPORT = "large";

export const FOUR_COLUMNS = "fourColumns";
export const THREE_COLUMNS = "threeColumns";
export const TWO_COLUMNS = "twoColumns";

const initialState = {
  isFilterOverlayVisible: false,
  isSortOverlayVisible: false,
  isFilterButtonFocused: false,
  isSecondaryListVisible: false,
  successMessage: {
    isVisible: false,
    message: "",
    linkText: "",
    linkUrl: "",
  },
  viewportCategory: SMALL_VIEWPORT,
  detectedFloor: null,
  clientWidth: null,
};

const iNoBounce = CLIENT
  ? require("inobounce")
  : { enable: () => {}, disable: () => {}, isScrollSupported: false };

const validateViewport = (state, viewport) =>
  [SMALL_VIEWPORT, MEDIUM_VIEWPORT, LARGE_VIEWPORT].includes(viewport)
    ? viewport
    : state.viewportCategory;

const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    showFilterOverlay: (state) => {
      document.body.style.overflow = "hidden";
      if (iNoBounce.isScrollSupported) {
        iNoBounce.enable();
      }

      state.isFilterOverlayVisible = true;
    },
    hideFilterOverlay: (state) => {
      document.body.style.overflow = "initial";
      state.isFilterButtonFocused = true;
      if (iNoBounce.isScrollSupported) {
        iNoBounce.disable();
      }

      state.isFilterOverlayVisible = false;
    },
    showSortOverlay: (state) => {
      document.body.style.overflow = "hidden";
      state.isFilterButtonFocused = false;
      if (iNoBounce.isScrollSupported) {
        iNoBounce.enable();
      }

      state.isSortOverlayVisible = true;
    },
    hideSortOverlay: (state) => {
      document.body.style.overflow = "initial";
      if (iNoBounce.isScrollSupported) {
        iNoBounce.disable();
      }

      state.isSortOverlayVisible = false;
    },
    toggleSecondaryList: (state) => {
      state.isSecondaryListVisible = !state.isSecondaryListVisible;
    },
    updateViewportCategory: {
      reducer: (state, action) => {
        state.viewportCategory = validateViewport(
          state,
          action.payload.viewportCategory,
        );
      },
      prepare: (viewportCategory) => ({
        payload: { viewportCategory },
      }),
    },
    updateClientWidth: {
      reducer: (state, action) => {
        state.clientWidth = action.payload.clientWidth;
      },
      prepare: (clientWidth) => ({
        payload: { clientWidth },
      }),
    },
    showSuccessMessage: (state, action) => {
      state.successMessage = {
        isVisible: true,
        message: action.payload.message,
        linkText: action.payload.linkText,
        linkUrl: action.payload.linkUrl,
      };
    },
    hideSuccessMessage: (state) => {
      state.successMessage = initialState.successMessage;
    },
    setDetectedFloor: (state, action) => {
      state.detectedFloor = action.payload;
    },
  },
});

export const {
  showFilterOverlay,
  hideFilterOverlay,
  showSortOverlay,
  hideSortOverlay,
  toggleSecondaryList,
  updateViewportCategory,
  updateClientWidth,
  showSuccessMessage,
  hideSuccessMessage,
  setDetectedFloor,
} = layoutSlice.actions;

export const SHOW_FILTER_OVERLAY = showFilterOverlay.type;
export const HIDE_FILTER_OVERLAY = hideFilterOverlay.type;
export const SHOW_SORT_OVERLAY = showSortOverlay.type;
export const HIDE_SORT_OVERLAY = hideSortOverlay.type;
export const TOGGLE_SECONDARY_LIST = toggleSecondaryList.type;
export const UPDATE_VIEWPORT_CATEGORY = updateViewportCategory.type;
export const UPDATE_CLIENT_WIDTH = updateClientWidth.type;
export const SHOW_SUCCESS_MESSAGE = showSuccessMessage.type;
export const HIDE_SUCCESS_MESSAGE = hideSuccessMessage.type;
export const SET_DETECTED_FLOOR = setDetectedFloor.type;

export default layoutSlice.reducer;
